export const uploadfileMixin = {
  data() {
    return {
      maxAllowedFileSize: 2048,
      filesSupportedErrorMsg:
        "Selected files are an unsupported extenstion. The expected exptensions are JPG, PNG, PDF, DOC.",
      fileSizeError:
        "Selected file exceeds the size limit. Maximum file size is 2MB each.",
      dropedFiles: [],
      errorSnackbar: false,
      attachmentFiles: [],
    };
  },

  methods: {
    handleFileImport() {
      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },

    onFileChanged(e) {
      if (e.target.files.length) {
        for (let i = 0; i < e.target.files.length; i++) {
          let file = e.target.files[i];
          this.validateUploadedFile(file);
          this.$refs.uploader.value = "";
        }
      }
    },
    validateUploadedFile(file) {
      if (
        file.type !== "application/pdf" &&
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "application/msword"
      ) {
        this.$store.dispatch("ui/snackbar", [
          {
            title: "Error",
            message: this.filesSupportedErrorMsg,
            type: "error",
          },
        ]);
      } else if (!this.isSizeValid(file)) {
        this.$store.dispatch("ui/snackbar", [
          {
            title: "Error",
            message: this.fileSizeError,
            type: "error",
          },
        ]);
      } else {
        if (this.dropedFiles.length) {
          let valueExist = false;
          this.dropedFiles.map((existFile) => {
            if (existFile.name === file.name) {
              valueExist = true;
            }
          });
          if (!valueExist) {
            this.dropedFiles.push(file);
          }
        } else {
          this.dropedFiles.push(file);
        }
      }
    },

    isSizeValid(file) {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize > this.maxAllowedFileSize) {
        return false;
      }
      return true;
    },
  },
};
